<a (click)="showServers()" class="container">
  <div class="first-row">
    <div>
      <span class="text">{{"ServerLink.Server" | translate}}</span>
      <span class="number">{{serverCount}}</span>
    </div>
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.4797 2.20989L10.44 8.4306C10.5855 8.58115 10.6577 8.7763 10.6577 8.97063C10.6577 9.16497 10.5855 9.36028 10.44 9.51067L4.4797 15.7314C4.18178 16.0437 3.68738 16.0538 3.37618 15.7548C3.06287 15.4577 3.05268 14.9612 3.35278 14.6509L8.82154 8.9413L3.35372 3.2903C3.05362 2.98105 3.06381 2.48366 3.37711 2.18646C3.68835 1.8873 4.18347 1.89772 4.4797 2.20989Z"
        fill="#828282" />
    </svg>
  </div>
  <div class="second-row">
    <span class="image" alt="flag">{{getCountryFlag(serverName)}}</span>
    <span class="server-name">{{serverName}}</span>
  </div>
</a>